/* Visible by default, no dependencies, no changes to product/variant/cart logic. */
(() => {
  const init = (root = document) => {
    if (!document.querySelector('.souvern-hero')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('souvern-reveal-active');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    root.querySelectorAll('[data-souvern-reveal], .souvern-collection .collection__title, .souvern-collection .product-grid > li').forEach((element) => {
      if (element.dataset.souvernObserved) return;
      element.dataset.souvernObserved = 'true';
      observer.observe(element);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
